<div class="ivr-number-configuration">
  <div class="number-configuration-selection-container">
    <div class="icon-container">
      <nb-icon class="levels-icon" icon="levels" pack="icomoon"></nb-icon>
    </div>
    <div class="select-menu-container">
      <div class="title-container">
        <div class="number-title">
          <h3>{{ label }}</h3>
        </div>
        <div *ngIf="canCreateNumberConfig || isPPIConfig" class="add-number-configuration-container global-transition" (click)="open()">
          <h3>{{ 'view_translations.' + ( isPPIConfig ? 'add_new_ppi_config' : 'add_new_ivr_number' ) | translate }}</h3>
        </div>
      </div>
      <div class="select-menu">
        <app-select-configuration-input [submitted]="submitted" [fieldInfo]="fieldInfo" (emitValue)="getValue($event)"> </app-select-configuration-input>
      </div>
    </div>
  </div>
</div>
